import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative flex flex-col text-12px w-full" }
const _hoisted_2 = { class: "flex flex-col sm:flex sm:flex-row gap-2" }
const _hoisted_3 = { class: "flex flex-row flex-no-wrap relative" }
const _hoisted_4 = { class: "space-y-2 px-2 pb-4" }
const _hoisted_5 = { class: "w-1/2 pl-2.5 py-2 border-r border-gray-lp-400" }
const _hoisted_6 = { class: "w-1/2 pl-2.5 py-2" }
const _hoisted_7 = { class: "w-full px-2.5 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_Select = _resolveComponent("Select")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode(_component_Skeleton, {
        height: "2rem",
        width: "15rem"
      }),
      _createVNode(_component_Skeleton, {
        height: "2rem",
        width: "15rem"
      }),
      _createVNode(_component_Skeleton, {
        height: "2rem",
        width: "15rem"
      }),
      _createVNode(_component_Skeleton, {
        height: "2rem",
        width: "15rem"
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: ["flex flex-col sm:flex sm:flex-row gap-2", [{ ' pt-4 pb-1': !_ctx.isV2 }]]
    }, [
      _createVNode(_component_Search, {
        onInput: _ctx.onSearch,
        onClear: _ctx.clearSearch,
        value: _ctx.searchValue,
        isIconLeft: "",
        isIconClearRight: "",
        class: "w-1/4 mb-1",
        placeholder: _ctx.$t('pickupV2.list.filter.searchPlaceholder'),
        customMargin: "mr-2"
      }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_AdvancedFilter, {
          periodeTitle: _ctx.$t('pickupV2.list.filter.pickupSchedule'),
          isNewPeriodTitle: true,
          isPeriode: true,
          isPeriodeStartOnly: true,
          "custom-max-height": "48vh",
          "model-value": _ctx.modelValue,
          isDisabled: false,
          onChange: _ctx.onChangePickupSchedule,
          onOpened: _ctx.onOpenedAdvancedFilter,
          onReset: _ctx.onResetAdvancedFilter,
          addSumFilter: _ctx.sumFilter,
          withMaxMinDate: false
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupV2.list.filter.vehicleType')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    selectedItem: _ctx.modelValue.lsTransportTypeId,
                    options: _ctx.transportTypeOptions,
                    placeholder: _ctx.$t('pickupV2.list.filter.vehicleTypePlaceholder'),
                    onSelect: _ctx.onSelectVehicle,
                    class: "mt-3"
                  }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupV2.list.filter.serviceType')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    class: "mt-3",
                    placeholder: 
                  _ctx.$t('bookingShipment.list.filter.selectServiceType')
                ,
                    value: 
                  _ctx.modelValue.lsServiceCodes?.length
                    ? `${_ctx.modelValue.lsServiceCodes.length} ${_ctx.$t(
                        'bookingShipment.list.filter.serviceType'
                      )}`
                    : ''
                
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_5, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index,
                            class: "p-field-checkbox mt-1"
                          }, [
                            (index < 5)
                              ? (_openBlock(), _createBlock(_component_Checkbox, {
                                  key: 0,
                                  name: "product",
                                  id: index,
                                  value: product.code,
                                  modelValue: _ctx.modelValue.lsServiceCodes,
                                  "onUpdate:modelValue": [
                                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.lsServiceCodes = $event)),
                                    _ctx.onChangeProduct
                                  ]
                                }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (index < 5)
                              ? (_openBlock(), _createBlock("label", {
                                  key: 1,
                                  for: String(index),
                                  class: "ml-2.5"
                                }, _toDisplayString(product.name), 9, ["for"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_6, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index,
                            class: "p-field-checkbox mt-1.5"
                          }, [
                            (index > 4)
                              ? (_openBlock(), _createBlock(_component_Checkbox, {
                                  key: 0,
                                  name: "product",
                                  id: index,
                                  value: product.code,
                                  modelValue: _ctx.modelValue.lsServiceCodes,
                                  "onUpdate:modelValue": [
                                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.lsServiceCodes = $event)),
                                    _ctx.onChangeProduct
                                  ]
                                }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (index > 4)
                              ? (_openBlock(), _createBlock("label", {
                                  key: 1,
                                  for: String(index),
                                  class: "ml-2.5"
                                }, _toDisplayString(product.name), 9, ["for"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupV2.list.filter.status')
              }, {
                default: _withCtx(() => [
                  (_ctx.isV2)
                    ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                        key: 0,
                        class: "mt-3",
                        placeholder: _ctx.$t('pickupV2.list.filter.statusPlaceholder'),
                        value: 
                  _ctx.modelValue.lsLastStatus?.length
                    ? `${_ctx.modelValue.lsLastStatus.length} ${_ctx.$t(
                        'bookingShipment.list.filter.status'
                      )}`
                    : ''
                
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_7, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusPickupSchedule, (status, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "p-field-checkbox mt-1"
                              }, [
                                _createVNode(_component_Checkbox, {
                                  name: "status",
                                  id: `status-${index}`,
                                  value: status.value,
                                  modelValue: _ctx.modelValue.lsLastStatus,
                                  "onUpdate:modelValue": [
                                    _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.lsLastStatus = $event)),
                                    _ctx.onChangeAdvancedFilter
                                  ]
                                }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue"]),
                                _createVNode("label", {
                                  for: String(`status-${index}`),
                                  class: "ml-2.5"
                                }, _toDisplayString(status.name), 9, ["for"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }, 8, ["placeholder", "value"]))
                    : (_openBlock(), _createBlock(_component_CustomDropdown, {
                        key: 1,
                        selectedItem: _ctx.modelValue.lsLastStatus,
                        options: _ctx.statusPickupSchedule,
                        placeholder: _ctx.$t('pickupV2.list.filter.statusPlaceholder'),
                        onSelect: _ctx.selectStatus,
                        class: "mt-3"
                      }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"]))
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["periodeTitle", "model-value", "onChange", "onOpened", "onReset", "addSumFilter"])
      ]),
      (!_ctx.isV2)
        ? (_openBlock(), _createBlock(_component_Select, {
            key: 0,
            dataSelect: _ctx.sortByData,
            onOpenSelect: _ctx.onOpenSortBy,
            onCloseSelect: _ctx.onCloseSortBy,
            onChooseSelect: _ctx.onSelectSortBy,
            value: _ctx.sortByTitle,
            isOpenMenu: _ctx.sortBySelect,
            isDefaultBlack: true,
            class: "w-49"
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"]))
        : _createCommentVNode("", true),
      (_ctx.isV2)
        ? (_openBlock(), _createBlock(_component_TimeRangePicker, {
            key: 1,
            startDate: _ctx.modelValue.startDate,
            endDate: _ctx.modelValue.endDate,
            onSelect: _ctx.setPeriode,
            default: "custom",
            isCloseDateAfterSelect: "",
            class: "w-1/4",
            isMounted: false
          }, null, 8, ["startDate", "endDate", "onSelect"]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: "fixed right-0 h-full z-20",
      style: 
        `background-color:rgba(0,0,0,0.3); top: 22rem; width: calc(100% - ${
          _ctx.isAdvancedFilterOpened ? '60px' : `264px`
        });`
      
    }, null, 4), [
      [_vShow, _ctx.isAdvancedFilterOpened && !_ctx.isV2]
    ])
  ]))
}